import {FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import {VehicleMonitoring} from '../pages/VehicleMonitoring'
import {AssignVehicleView} from '../pages/AssignVehicleView'
import {useDataLayerValue} from '../../DataLayer'

const PrivateRoutes = () => {
  const [{policies}] = useDataLayerValue()

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/vehicle-monitoring' />} />
        <Route
          path='/vehicle-monitoring'
          element={
            [22.2].some((number) => policies?.includes(number)) ? (
              <SuspensedView>
                <VehicleMonitoring
                  allJobs={undefined}
                  fetchAllJobs={function (): void {
                    throw new Error('Function not implemented.')
                  }}
                />
              </SuspensedView>
            ) : (
              <Navigate to='/error/404' />
            )
          }
        />
        <Route
          path='/assign-vehicle-view'
          element={
            [22.1].some((number) => policies?.includes(number)) ? (
              <SuspensedView>
                <AssignVehicleView
                  allJobs={undefined}
                  fetchAllJobs={function (): void {
                    throw new Error('Function not implemented.')
                  }}
                />
              </SuspensedView>
            ) : (
              <Navigate to='/error/404' />
            )
          }
        />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
